// Mercedes-Benz three-pointed star logo (custom SVG since react-icons/si has no SiMercedes)
export const MercedesLogo = (props) => (
  <svg viewBox="0 0 64 64" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-label="Mercedes-Benz" {...props}>
    <path d="M32 2a30 30 0 1 0 0 60 30 30 0 0 0 0-60Zm0 4a26 26 0 1 1 0 52 26 26 0 0 1 0-52Z" />
    {/* Three-pointed star */}
    <path d="M32 8 33.6 30.4 56 32l-22.4 1.6L32 56l-1.6-22.4L8 32l22.4-1.6L32 8Z" />
  </svg>
);

export default MercedesLogo;
